import { useMemo } from 'preact/hooks'
import { useContext } from 'preact/compat'
import BaseContext from 'contexts/base-context'

export default function useBrandingProps() {
  const { formSetting: setting } = useContext(BaseContext)
  const brandingUrl = setting?.brandingUrl
  const brandingVisible = useMemo(() => {
    return brandingUrl !== null
  }, [brandingUrl])
  return {
    brandingUrl,
    brandingVisible,
  }
}
